<template>
  <footer>
    <div class="wrap fgrid">
      <div class="fmeta">
        <div>© 2026 myVPS</div>
        <div>SOFTEKA - FZCO</div>
        <div>55022</div>
        <div>IFZA Business Park, DDP, PO Box 342001, Dubai, United Arab Emirates</div>
      </div>
      <div>
        <router-link to="/documents/terms">Оферта</router-link>
        ·
        <router-link to="/documents/privacy">Политика обработки персональных данных</router-link>
      </div>
    </div>
  </footer>
</template>
